import React from "react";

const Decoration3 = () => {
  return (
    <div className="py-3">
      <img
        src="https://templates.microweber.com/wedding/userfiles/templates/wedding/assets/img/decoration-3.svg"
        alt="decoration-3"
        className="max-h-[40px] max-w-[500px] m-auto w-3/4 md:w-full"
      />
    </div>
  );
};

export default Decoration3;
